import { createRoute, useNavigate } from "@tanstack/react-router";
import { useSession } from "@/auth/client";
import { TargetsPage } from "@/components/targets/targets-page";
import { Route as authenticatedRoute } from "../_authenticated";

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/targets",
  component: TargetsGuard,
});

function TargetsGuard() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  if ((session?.user as any)?.role !== "admin") {
    navigate({ to: "/my-dashboard" });
    return null;
  }

  return <TargetsPage />;
}
